<!-- Orders Page -->
<div class="orders-container">

    <!-- Sub-tabs -->
    <div class="orders-tabs-wrapper">
        <div class="orders-tabs">
            <button class="tab-btn"
                [class.active]="activeSubTab === 'purchaseOrders'"
                (click)="onSubTabChange('purchaseOrders')">
                Purchase Orders
            </button>
            <button class="tab-btn"
                [class.active]="activeSubTab === 'hyperpureOrders'"
                (click)="onSubTabChange('hyperpureOrders')">
                Hyperpure Orders
            </button>
            <button class="tab-btn"
                [class.active]="activeSubTab === 'udaanOrders'"
                (click)="onSubTabChange('udaanOrders')">
                Udaan Orders
            </button>
            <button class="tab-btn"
                [class.active]="activeSubTab === 'dmartOrders'"
                (click)="onSubTabChange('dmartOrders')">
                DMart Orders
            </button>
            <button class="tab-btn"
                [class.active]="activeSubTab === 'deliveritOrders'"
                (click)="onSubTabChange('deliveritOrders')">
                DeliverIt Orders
            </button>
        </div>
    </div>

    <!-- Purchase Orders Tab -->
    <div class="tab-content"
        *ngIf="activeSubTab === 'purchaseOrders'">

        <!-- Toolbar -->
        <div class="orders-toolbar">
            <div class="orders-search-wrapper">
                <div class="orders-search">
                    <i class="material-icons">search</i>
                    <input type="text"
                        [(ngModel)]="poSearchQuery"
                        placeholder="Search PO Number or Supplier"
                        (keydown.enter)="onPoSearch()" />
                </div>
            </div>

            <div class="toolbar-right">
                <!-- Date range picker removed -->
            </div>
        </div>

        <!-- Loading -->
        <div class="loading-state"
            *ngIf="isPoLoading">
            <div class="spinner"></div>
            <span>Loading orders...</span>
        </div>

        <!-- Table -->
        <div class="orders-table-wrapper"
            *ngIf="!isPoLoading && purchaseOrders.length > 0">
            <table class="orders-table">
                <thead>
                    <tr>
                        <th style="width: 15%">PO Number</th>
                        <th style="width: 15%">Date</th>
                        <th style="width: 25%">Supplier</th>
                        <th style="width: 12%"
                            class="items-count-cell">No. of items</th>
                        <th style="width: 13%"
                            class="amount-cell">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let order of purchaseOrders">
                        <td class="po-number-cell">{{ order.poNumber || '-' }}</td>
                        <td class="date-cell">{{ order.createdAt | date:'dd MMM yyyy' }}</td>
                        <td>
                            <span class="supplier-name">{{ order.supplierName || order.supplierAlias || '-' }}</span>
                        </td>
                        <td class="items-count-cell">{{ order.items?.length || 0 }}</td>
                        <td class="amount-cell">{{ order.totalAmount | number:'1.0-0' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Empty State -->
        <div class="empty-state"
            *ngIf="!isPoLoading && purchaseOrders.length === 0">
            <i class="material-icons">inbox</i>
            <h3>No purchase orders found</h3>
            <p>Create purchase orders from the comparison page.</p>
        </div>

        <!-- Pagination -->
        <div class="p-3 mt-auto"
            *ngIf="poPagination.totalItems > 0">
            <app-invoice-pagination [pageSize]="poPagination.pageSize"
                [page]="poPagination.page"
                [count]="poPagination.totalItems"
                pageName="Order"
                (pageChange)="onPoPageChange($event)"
                (pageSizeChange)="onPoPageSizeChange($event)">
            </app-invoice-pagination>
        </div>
    </div>

    <!-- Hyperpure Orders Tab -->
    <div class="tab-content"
        *ngIf="activeSubTab === 'hyperpureOrders'">

        <!-- Toolbar -->
        <div class="orders-toolbar">
            <div class="orders-search-wrapper">
                <div class="orders-search">
                    <i class="material-icons">search</i>
                    <input type="text"
                        [(ngModel)]="hpSearchTerm"
                        placeholder="Search by Order #"
                        (keydown.enter)="onHpSearch()" />
                </div>
            </div>

            <div class="toolbar-right">
                <select class="page-size-select"
                    style="height: 40px; border: 1px solid #e0e0e0; border-radius: 8px; padding: 0 12px; font-size: 13px; color: #424242; outline: none; cursor: pointer;"
                    [(ngModel)]="hpSelectedStatus"
                    (change)="onHpStatusChange()">
                    <option *ngFor="let opt of hpStatusOptions"
                        [value]="opt.value">{{ opt.label }}</option>
                </select>
            </div>
        </div>

        <div class="loading-state"
            *ngIf="isHpLoading">
            <div class="spinner"></div>
            <span>Loading orders...</span>
        </div>

        <div class="orders-table-wrapper"
            *ngIf="!isHpLoading && hyperpureOrders.length > 0">
            <table class="orders-table">
                <thead>
                    <tr>
                        <th class="po-number-cell">Order #</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Amount</th>
                        <th class="text-center">Invoice</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let order of hyperpureOrders"
                        class="hp-order-row"
                        (click)="openHpOrderDetails(order)">
                        <td class="po-number-cell">{{ order.orderNumber }}</td>
                        <td>{{ formatHpDate(order.orderPlacedAt) }}</td>
                        <td>
                            <span class="status-badge"
                                [ngClass]="getHpStatusBadgeClass(order.orderStatus)">
                                {{ order.orderStatus }}
                            </span>
                        </td>
                        <td class="amount-cell">{{ formatHpCurrency(order.totalOrderedValue) }}</td>
                        <td class="text-center">
                            <button class="hp-invoice-view-btn"
                                *ngIf="hasHpInvoice(order)"
                                (click)="viewHpInvoice(order); $event.stopPropagation()"
                                title="View Invoice">
                                <i class="material-icons">visibility</i>
                                <span>View</span>
                            </button>
                            <span class="hp-invoice-unavailable"
                                *ngIf="!hasHpInvoice(order)">—</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Empty State -->
        <div class="empty-state"
            *ngIf="!isHpLoading && hyperpureOrders.length === 0">
            <i class="material-icons">inbox</i>
            <h3>No Hyperpure orders found</h3>
            <p>Try adjusting your search or filters.</p>
        </div>

        <!-- Pagination -->
        <div class="p-3 mt-auto"
            *ngIf="hpPagination.totalOrders > 0">
            <app-invoice-pagination [pageSize]="hpPagination.pageSize"
                [page]="hpPagination.currentPage"
                [count]="hpPagination.totalOrders"
                pageName="Order"
                (pageChange)="onHpPageChange($event)"
                (pageSizeChange)="onHpPageSizeChange($event)">
            </app-invoice-pagination>
        </div>
    </div>

    <!-- Udaan Orders Tab -->
    <div class="tab-content"
        *ngIf="activeSubTab === 'udaanOrders'">

        <!-- Toolbar -->
        <div class="orders-toolbar">
            <div class="orders-search-wrapper">
                <div class="orders-search">
                    <i class="material-icons">search</i>
                    <input type="text"
                        placeholder="Search Udaan Orders"
                        disabled />
                </div>
            </div>
        </div>

        <div class="empty-state">
            <i class="material-icons">local_shipping</i>
            <h3>No Udaan orders found</h3>
            <p>Orders placed via Udaan will appear here.</p>
        </div>
    </div>

    <!-- DMart Orders Tab -->
    <div class="tab-content"
        *ngIf="activeSubTab === 'dmartOrders'">

        <!-- Toolbar -->
        <div class="orders-toolbar">
            <div class="orders-search-wrapper">
                <div class="orders-search">
                    <i class="material-icons">search</i>
                    <input type="text"
                        [(ngModel)]="dmartSearchQuery"
                        placeholder="Search by Order ID"
                        (keydown.enter)="onDmartSearch()" />
                </div>
            </div>
        </div>

        <!-- Loading -->
        <div class="loading-state"
            *ngIf="isDmartLoading">
            <div class="spinner"></div>
            <span>Loading DMart orders...</span>
        </div>

        <!-- Table -->
        <div class="orders-table-wrapper"
            *ngIf="!isDmartLoading && dmartOrders.length > 0">
            <table class="orders-table">
                <thead>
                    <tr>
                        <th style="width: 18%">Order ID</th>
                        <th style="width: 18%">Date</th>
                        <th style="width: 15%">Status</th>
                        <th style="width: 15%"
                            class="amount-cell">Amount</th>
                        <th style="width: 15%"
                            class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let order of dmartOrders">
                        <td class="po-number-cell">{{ order.orderId || '-' }}</td>
                        <td class="date-cell">{{ formatDmartDate(order.orderDate) }}</td>
                        <td>
                            <span class="status-badge"
                                [ngClass]="getDmartStatusBadgeClass(order.orderStatus)">
                                {{ order.orderStatusText }}
                            </span>
                        </td>
                        <td class="amount-cell">{{ formatDmartCurrency(order.grandTotal) }}</td>
                        <td class="text-center">
                            <button class="btn btn-sm btn-outline-primary"
                                (click)="onDownloadDmartInvoice(order); $event.stopPropagation()"
                                [disabled]="order.isDownloading"
                                style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; font-size: 13px;"
                                title="Download Invoice">
                                <i class="material-icons"
                                    *ngIf="!order.isDownloading"
                                    style="font-size: 16px;">download</i>
                                <span class="spinner-border spinner-border-sm"
                                    *ngIf="order.isDownloading"
                                    style="width: 14px; height: 14px; border-width: 2px;"></span>
                                <span>Invoice</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Empty State -->
        <div class="empty-state"
            *ngIf="!isDmartLoading && dmartOrders.length === 0">
            <i class="material-icons">shopping_cart</i>
            <h3>No DMart orders found</h3>
            <p>Orders placed via DMart will appear here.</p>
        </div>

        <!-- Pagination -->
        <div class="p-3 mt-auto"
            *ngIf="dmartPagination.totalRecords > 0">
            <app-invoice-pagination [pageSize]="dmartPagination.pageSize"
                [page]="dmartPagination.page"
                [count]="dmartPagination.totalRecords"
                pageName="Order"
                (pageChange)="onDmartPageChange($event)"
                (pageSizeChange)="onDmartPageSizeChange($event)">
            </app-invoice-pagination>
        </div>
    </div>

    <!-- DeliverIt Orders Tab -->
    <div class="tab-content"
        *ngIf="activeSubTab === 'deliveritOrders'">

        <!-- Toolbar -->
        <div class="orders-toolbar">
            <div class="orders-search-wrapper">
                <div class="orders-search">
                    <i class="material-icons">search</i>
                    <input type="text"
                        [(ngModel)]="deliveritSearchTerm"
                        placeholder="Search by Order ID or Customer"
                        (keydown.enter)="onDeliveritSearch()" />
                </div>
            </div>

            <div class="toolbar-right">
                <select class="page-size-select"
                    style="height: 40px; border: 1px solid #e0e0e0; border-radius: 8px; padding: 0 12px; font-size: 13px; color: #424242; outline: none; cursor: pointer;"
                    [(ngModel)]="deliveritSelectedStatus"
                    (change)="onDeliveritStatusChange()">
                    <option *ngFor="let opt of deliveritStatusOptions"
                        [value]="opt.value">{{ opt.label }}</option>
                </select>
            </div>
        </div>

        <!-- Loading -->
        <div class="loading-state"
            *ngIf="isDeliveritLoading">
            <div class="spinner"></div>
            <span>Loading DeliverIt orders...</span>
        </div>

        <div class="orders-table-wrapper"
            *ngIf="!isDeliveritLoading && deliveritOrders.length > 0">
            <table class="orders-table">
                <thead>
                    <tr>
                        <th class="po-number-cell">Order #</th>
                        <th>Date</th>
                        <th>Customer</th>
                        <th>Status</th>
                        <th class="amount-cell">Amount</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let order of deliveritOrders">
                        <td class="po-number-cell">{{ order.orderId }}</td>
                        <td>{{ formatDeliveritDate(order.orderDate) }}</td>
                        <td>{{ order.customer?.name || '-' }}</td>
                        <td>
                            <span class="status-badge"
                                [ngClass]="getDeliveritStatusBadgeClass(order.orderStatus)">
                                {{ order.orderStatus }}
                            </span>
                        </td>
                        <td class="amount-cell">{{ formatDeliveritCurrency(order.pricing?.totalAmount) }}</td>
                        <td class="text-center">
                            <button class="btn btn-sm btn-outline-primary"
                                *ngIf="order.orderStatus === 'DELIVERED'"
                                (click)="downloadDeliveritInvoice(order); $event.stopPropagation()"
                                style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; font-size: 13px;"
                                title="Download Invoice">
                                <i class="material-icons" style="font-size: 16px;">download</i>
                                <span>Invoice</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Empty State -->
        <div class="empty-state"
            *ngIf="!isDeliveritLoading && deliveritOrders.length === 0">
            <i class="material-icons">inbox</i>
            <h3>No DeliverIt orders found</h3>
            <p>Try adjusting your search or filters.</p>
        </div>

        <!-- Pagination -->
        <div class="p-3 mt-auto"
            *ngIf="deliveritPagination.totalOrders > 0">
            <app-invoice-pagination [pageSize]="deliveritPagination.pageSize"
                [page]="deliveritPagination.currentPage"
                [count]="deliveritPagination.totalOrders"
                pageName="Order"
                (pageChange)="onDeliveritPageChange($event)"
                (pageSizeChange)="onDeliveritPageSizeChange($event)">
            </app-invoice-pagination>
        </div>
    </div>

</div>

<!-- Hyperpure Order Details -->
<div class="hp-invoice-overlay"
    *ngIf="showHpOrderDetails"
    (click)="closeHpOrderDetails()"></div>
<div class="hp-order-details-modal"
    *ngIf="showHpOrderDetails && selectedHpOrder"
    role="dialog"
    aria-modal="true"
    aria-labelledby="hpOrderDetailsTitle"
    (click)="$event.stopPropagation()">
    <div class="hp-invoice-header">
        <div class="hp-invoice-title-wrap">
            <i class="material-icons">receipt_long</i>
            <div>
                <h5 id="hpOrderDetailsTitle">Order details</h5>
                <p>{{ selectedHpOrder.orderNumber }}</p>
            </div>
        </div>
        <div class="hp-invoice-actions">
            <button type="button"
                class="hp-invoice-download-btn"
                *ngIf="hasHpInvoice(selectedHpOrder)"
                (click)="viewHpInvoice(selectedHpOrder)"
                title="View Invoice">
                <i class="material-icons">visibility</i>
                <span>View Invoice</span>
            </button>
            <button type="button"
                class="hp-invoice-close-btn"
                (click)="closeHpOrderDetails()"
                aria-label="Close order details">
                <i class="material-icons">close</i>
            </button>
        </div>
    </div>

    <div class="hp-order-details-body">
        <div class="hp-order-meta-grid">
            <div class="hp-order-meta-card">
                <span>Status</span>
                <strong>
                    <span class="status-badge"
                        [ngClass]="getHpStatusBadgeClass(selectedHpOrder.orderStatus)">
                        {{ selectedHpOrder.orderStatus }}
                    </span>
                </strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Payment</span>
                <strong>
                    <span class="status-badge"
                        [ngClass]="getHpPaymentStatusBadgeClass(selectedHpOrder.paymentStatus)">
                        {{ selectedHpOrder.paymentStatus | uppercase }}
                    </span>
                </strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Order date</span>
                <strong>{{ formatHpDate(selectedHpOrder.orderPlacedAt) }}</strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Delivery date</span>
                <strong>{{ formatHpDate(selectedHpOrder.targetDeliveryDate) }}</strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Outlet</span>
                <strong>{{ selectedHpOrder.buyerOutletName || '-' }}</strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Delivery slot</span>
                <strong>{{ selectedHpOrder.deliveryTimeSlot || '-' }}</strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Weight</span>
                <strong>{{ selectedHpOrder.totalOrderWeight || 0 }} kg</strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Order value</span>
                <strong>{{ formatHpCurrency(selectedHpOrder.totalOrderedValue) }}</strong>
            </div>
            <div class="hp-order-meta-card">
                <span>Invoiced value</span>
                <strong>{{ formatHpCurrency(selectedHpOrder.totalInvoicedValue) }}</strong>
            </div>
        </div>

        <p class="hp-order-instructions"
            *ngIf="selectedHpOrder.orderInstructions">
            <strong>Instructions:</strong> {{ selectedHpOrder.orderInstructions }}
        </p>

        <div class="hp-order-section">
            <h6>Items ({{ selectedHpOrder.orderItems?.length || 0 }})</h6>
            <div class="hp-order-items-table-wrap">
                <table class="hp-order-items-table">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th class="text-center">Ordered</th>
                            <th class="text-center">Invoiced</th>
                            <th class="text-end">Rate</th>
                            <th class="text-end">Discount</th>
                            <th class="text-end">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of selectedHpOrder.orderItems">
                            <td>
                                <div class="hp-item-name">{{ formatHpItemName(item) }}</div>
                                <div class="hp-item-meta"
                                    *ngIf="item.hsnCode">HSN {{ item.hsnCode }}
                                    <span *ngIf="item.gstRate">· GST {{ item.gstRate }}%</span>
                                </div>
                            </td>
                            <td class="text-center">{{ item.orderedQuantity }}</td>
                            <td class="text-center">{{ item.invoicedQuantity }}</td>
                            <td class="text-end">{{ formatHpCurrency(item.pricePerUnit) }}</td>
                            <td class="text-end">{{ formatHpCurrency(item.discount) }}</td>
                            <td class="text-end">{{ formatHpCurrency(item.invoicedQuantityPrice || item.orderedQuantityPrice) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="hp-order-section"
            *ngIf="selectedHpOrder.invoices?.length">
            <h6>Invoices ({{ selectedHpOrder.invoices.length }})</h6>
            <div class="hp-order-invoice-list">
                <div class="hp-order-invoice-row"
                    *ngFor="let invoice of selectedHpOrder.invoices">
                    <div>
                        <div class="hp-item-name">{{ invoice.invoiceNumber }}</div>
                        <div class="hp-item-meta">{{ formatHpInvoiceType(invoice.invoiceType) }}</div>
                    </div>
                    <span class="hp-item-meta"
                        *ngIf="!invoice.storedS3Key">Stored copy unavailable</span>
                </div>
            </div>
        </div>
    </div>
</div>
